import React from 'react';
import Navbar from '../components/Navbar';
import WorkHero from '../components/works/WorkHero';

function WorkPage() {
  return (
    <>
      <Navbar />
      <WorkHero />
    </>
  );
}

export default WorkPage;